var _rect, _rect2, _mask, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanadianFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 0.0000610352,
    width: 6,
    height: 18,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 6,
    height: 18,
    rx: 1,
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2233_44453",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 24,
    height: 18,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 24,
    height: 18,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_2233_44453)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_44453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7543 14.0001C11.6146 14.0001 11.502 13.8856 11.5043 13.7459L11.526 12.437C11.5279 12.3947 11.5203 12.3526 11.5038 12.3136C11.4873 12.2747 11.4623 12.2399 11.4306 12.2119C11.3989 12.1839 11.3613 12.1634 11.3206 12.1518C11.2799 12.1403 11.2371 12.138 11.1954 12.1452L9.41295 12.5012C9.2219 12.5394 9.06255 12.354 9.12895 12.1709L9.32309 11.6353C9.3371 11.5974 9.33889 11.556 9.32821 11.517C9.31753 11.4781 9.29491 11.4434 9.26353 11.4179L6.77228 9.40057C6.62874 9.28433 6.65647 9.05792 6.82383 8.97976L7.09281 8.85416C7.13545 8.83401 7.16926 8.79899 7.1879 8.75568C7.20654 8.71236 7.20873 8.66373 7.19405 8.61892L6.77409 7.32742C6.71458 7.14442 6.87548 6.96561 7.06373 7.00555L8.2541 7.25813C8.29783 7.26724 8.34336 7.26096 8.38298 7.24033C8.42259 7.21971 8.45386 7.18602 8.47147 7.14497L8.63354 6.76373C8.70434 6.59718 8.92316 6.55871 9.04652 6.69112L10.0437 7.76135C10.0725 7.79173 10.1104 7.81195 10.1516 7.81898C10.1929 7.82602 10.2353 7.81948 10.2726 7.80036C10.3098 7.78124 10.3398 7.75056 10.3582 7.71293C10.3765 7.67529 10.3821 7.63273 10.3742 7.59162L9.87119 4.99768C9.83038 4.78719 10.0561 4.62635 10.2417 4.73364L10.7405 5.0219C10.7633 5.0353 10.7887 5.04386 10.815 5.04705C10.8413 5.05025 10.868 5.04801 10.8934 5.04047C10.9188 5.03293 10.9424 5.02026 10.9627 5.00323C10.983 4.98621 10.9996 4.9652 11.0114 4.9415L11.7772 3.43757C11.8699 3.25549 12.1301 3.25549 12.2228 3.43757L12.9886 4.9415C13.0004 4.9652 13.017 4.98621 13.0373 5.00323C13.0577 5.02026 13.0812 5.03293 13.1066 5.04047C13.132 5.04801 13.1587 5.05025 13.185 5.04705C13.2113 5.04386 13.2367 5.0353 13.2596 5.0219L13.7583 4.73364C13.9439 4.62635 14.1696 4.78719 14.1288 4.99768L13.6258 7.59162C13.6179 7.63273 13.6235 7.67529 13.6419 7.71293C13.6602 7.75056 13.6902 7.78124 13.7275 7.80036C13.7647 7.81948 13.8071 7.82602 13.8484 7.81898C13.8897 7.81195 13.9275 7.79173 13.9563 7.76135L14.9535 6.69112C15.0769 6.55871 15.2957 6.59718 15.3665 6.76373L15.5285 7.14497C15.5462 7.18602 15.5774 7.21971 15.617 7.24033C15.6567 7.26096 15.7022 7.26724 15.7459 7.25813L16.9363 7.00555C17.1245 6.96561 17.2854 7.14442 17.2259 7.32742L16.806 8.61892C16.7913 8.66373 16.7935 8.71236 16.8121 8.75568C16.8308 8.79899 16.8646 8.83401 16.9072 8.85416L17.1762 8.97976C17.3435 9.05792 17.3713 9.28433 17.2277 9.40057L14.7365 11.4179C14.7051 11.4434 14.6825 11.4781 14.6718 11.517C14.6611 11.556 14.6629 11.5974 14.6769 11.6353L14.871 12.1707C14.9374 12.3539 14.778 12.5393 14.5869 12.501L12.8085 12.1452C12.7668 12.138 12.7241 12.1403 12.6834 12.1518C12.6427 12.1634 12.6051 12.1839 12.5734 12.2119C12.5417 12.2399 12.5166 12.2747 12.5001 12.3136C12.4836 12.3526 12.4761 12.3947 12.478 12.437L12.4965 13.7465C12.4985 13.886 12.386 14.0001 12.2466 14.0001H11.7543Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_44453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 3.00006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadianFlag);
export default __webpack_public_path__ + "static/media/canadian-flag.42c323b6caff2fe437f0b529fbf05454.svg";
export { ForwardRef as ReactComponent };